// Form 130-U - Application for Texas Title

export const generateForm130U = (dealData) => {
  console.log('Generating Form 130-U with data:', dealData);
  const today = new Date().toLocaleDateString();
  const vehicle = dealData?.vehicle || dealData?.vehicles_db2025 || {};
  const customer = dealData?.customer || {};
  
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <title>Form 130-U - Application for Texas Title</title>
      <style>
        @media print {
          body { margin: 0; padding: 20px; }
          .no-print { display: none; }
        }
        body { font-family: Arial, sans-serif; font-size: 12px; line-height: 1.5; }
        .form-header { text-align: center; font-weight: bold; margin-bottom: 20px; }
        .section { margin-bottom: 15px; border: 1px solid #000; padding: 10px; }
        .row { display: flex; margin-bottom: 8px; }
        .field { flex: 1; padding: 0 5px; }
        .label { font-weight: bold; font-size: 10px; text-transform: uppercase; }
        .value { border-bottom: 1px solid #333; min-height: 20px; padding: 2px; }
        .checkbox { display: inline-block; width: 15px; height: 15px; border: 1px solid #000; margin-right: 5px; }
        .signature-line { border-bottom: 1px solid #000; margin-top: 20px; min-height: 30px; }
        h2 { font-size: 16px; text-align: center; }
        h3 { font-size: 14px; margin: 10px 0; }
      </style>
    </head>
    <body>
      <div class="form-header">
        <h2>FORM 130-U<br/>APPLICATION FOR TEXAS TITLE AND/OR REGISTRATION</h2>
        <p>Texas Department of Motor Vehicles</p>
      </div>
      
      <div class="section">
        <h3>SECTION 1: VEHICLE INFORMATION</h3>
        <div class="row">
          <div class="field">
            <div class="label">Year</div>
            <div class="value">${vehicle.year || ''}</div>
          </div>
          <div class="field">
            <div class="label">Make</div>
            <div class="value">${vehicle.make || ''}</div>
          </div>
          <div class="field">
            <div class="label">Model</div>
            <div class="value">${vehicle.model || ''}</div>
          </div>
        </div>
        <div class="row">
          <div class="field">
            <div class="label">Vehicle Identification Number (VIN)</div>
            <div class="value">${vehicle.vin || ''}</div>
          </div>
          <div class="field">
            <div class="label">Body Style</div>
            <div class="value">${vehicle.body_type || ''}</div>
          </div>
        </div>
        <div class="row">
          <div class="field">
            <div class="label">Color</div>
            <div class="value">${vehicle.color || ''}</div>
          </div>
          <div class="field">
            <div class="label">Odometer Reading</div>
            <div class="value">${vehicle.mileage || ''}</div>
          </div>
          <div class="field">
            <div class="label">Fuel Type</div>
            <div class="value">${vehicle.fuel_type || 'Gasoline'}</div>
          </div>
        </div>
      </div>
      
      <div class="section">
        <h3>SECTION 2: OWNER INFORMATION</h3>
        <div class="row">
          <div class="field">
            <div class="label">First Name</div>
            <div class="value">${customer.firstName || ''}</div>
          </div>
          <div class="field">
            <div class="label">Middle Name</div>
            <div class="value">${customer.middleName || ''}</div>
          </div>
          <div class="field">
            <div class="label">Last Name</div>
            <div class="value">${customer.lastName || ''}</div>
          </div>
        </div>
        <div class="row">
          <div class="field">
            <div class="label">Street Address</div>
            <div class="value">${customer.address || ''}</div>
          </div>
        </div>
        <div class="row">
          <div class="field">
            <div class="label">City</div>
            <div class="value">${customer.city || ''}</div>
          </div>
          <div class="field">
            <div class="label">State</div>
            <div class="value">${customer.state || 'TX'}</div>
          </div>
          <div class="field">
            <div class="label">ZIP Code</div>
            <div class="value">${customer.zipCode || ''}</div>
          </div>
        </div>
        <div class="row">
          <div class="field">
            <div class="label">Driver License Number</div>
            <div class="value">${customer.driversLicense || ''}</div>
          </div>
          <div class="field">
            <div class="label">Phone Number</div>
            <div class="value">${customer.phone || ''}</div>
          </div>
        </div>
      </div>
      
      <div class="section">
        <h3>SECTION 3: SALES TAX INFORMATION</h3>
        <div class="row">
          <div class="field">
            <div class="label">Sale Price</div>
            <div class="value">$${dealData?.pricing?.vehiclePrice || ''}</div>
          </div>
          <div class="field">
            <div class="label">Trade-In Allowance</div>
            <div class="value">$${dealData?.trade?.allowance || '0'}</div>
          </div>
          <div class="field">
            <div class="label">Taxable Amount</div>
            <div class="value">$${(dealData?.pricing?.vehiclePrice - (dealData?.trade?.allowance || 0)) || ''}</div>
          </div>
        </div>
      </div>
      
      <div class="section">
        <h3>SIGNATURES</h3>
        <div class="row">
          <div class="field">
            <div class="label">Applicant Signature</div>
            <div class="signature-line"></div>
            <div class="label">Date: ${today}</div>
          </div>
          <div class="field">
            <div class="label">Dealer Representative</div>
            <div class="signature-line"></div>
            <div class="label">Date: ${today}</div>
          </div>
        </div>
      </div>
      
      <div class="section">
        <h3>DEALER INFORMATION</h3>
        <p><strong>Paradise-Performance</strong><br/>
        1301 N Watson Rd Suite 128, Arlington, TX 76006<br/>
        Phone: (817) 382-2316<br/>
        Dealer License #: [Your License Number]</p>
      </div>
    </body>
    </html>
  `;
};
